// ===== RUTAS DE LA APLICACIÓN =====

export enum AppRoutes {
  HOME = '/home',
  CREATE_PQRS = '/create-pqrs',
  CREATE_PUBLIC_PQRS = '/create-public-pqrs',
  CHANGE_PASSWORD = '/change-password',
  PQRS_DETAILS = '/pqrs-details',
  UNAUTHORIZED = '/unauthorized'
}

// ===== MAPPING DE RUTAS PARA NAVEGACIÓN =====
export const ROUTE_PATHS = {
  [AppRoutes.HOME]: 'home',
  [AppRoutes.CREATE_PQRS]: 'create-pqrs',
  [AppRoutes.CREATE_PUBLIC_PQRS]: 'create-public-pqrs',
  [AppRoutes.CHANGE_PASSWORD]: 'change-password',
  [AppRoutes.PQRS_DETAILS]: 'pqrs-details',
  [AppRoutes.UNAUTHORIZED]: 'unauthorized'
} as const;

// ===== MAPPING DE RUTAS PARA TÍTULOS =====
export const ROUTE_TITLES = {
  [AppRoutes.HOME]: 'common.titles.requests',
  [AppRoutes.CREATE_PQRS]: 'common.titles.newRequest',
  [AppRoutes.CREATE_PUBLIC_PQRS]: 'common.titles.newRequest',
  [AppRoutes.CHANGE_PASSWORD]: 'common.titles.changePassword',
  [AppRoutes.PQRS_DETAILS]: 'common.titles.requestDetails',
  [AppRoutes.UNAUTHORIZED]: 'common.titles.unauthorized'
} as const;
